export const notificationConstants = {
    CREATE_REQUEST: 'NOTIFICATION_CREATE_REQUEST',
    CREATE_SUCCESS: 'NOTIFICATION_CREATE_SUCCESS',
    CREATE_FAILURE: 'NOTIFICATION_CREATE_FAILURE',

    UPDATE_REQUEST: 'NOTIFICATION_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'NOTIFICATION_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'NOTIFICATION_UPDATE_FAILURE',
    
    FETCH_TYPES_REQUEST: 'NOTIFICATION_FETCH_TYPES_REQUEST',
    FETCH_TYPES_SUCCESS: 'NOTIFICATION_FETCH_TYPES_SUCCESS',
    FETCH_TYPES_FAILURE: 'NOTIFICATION_FETCH_TYPES_FAILURE',

    FETCH_NOTIFICATIONS_REQUEST: 'NOTIFICATION_FETCH_NOTIFICATIONS_REQUEST',
    FETCH_NOTIFICATIONS_SUCCESS: 'NOTIFICATION_FETCH_NOTIFICATIONS_SUCCESS',
    FETCH_NOTIFICATIONS_FAILURE: 'NOTIFICATION_FETCH_NOTIFICATIONS_FAILURE',

    REMOVE_REQUEST: 'NOTIFICATION_REMOVE_REQUEST',
    REMOVE_SUCCESS: 'NOTIFICATION_REMOVE_SUCCESS',
    REMOVE_FAILURE: 'NOTIFICATION_REMOVE_FAILURE',

    FETCH_REQUEST: 'NOTIFICATION_FETCH_REQUEST',
    FETCH_SUCCESS: 'NOTIFICATION_FETCH_SUCCESS',
    FETCH_FAILURE: 'NOTIFICATION_FETCH_FAILURE',   

    GET_REQUEST: 'NOTIFICATION_GET_REQUEST',
    GET_SUCCESS: 'NOTIFICATION_GET_SUCCESS',
    GET_FAILURE: 'NOTIFICATION_GET_FAILURE',
};
